/* Adapt the quiet chat launcher to the surface beneath it; no frame loop. */
(()=>{
 const b=document.querySelector('[data-tide-chat]');if(!b)return;
 let queued=false;
 const rgb=s=>{const m=s.match(/^rgba?\(([^)]+)\)/);if(!m)return null;const v=m[1].split(/[ ,/]+/).map(Number);return [v[0],v[1],v[2],v.length>3?v[3]:1]};
 function surface(x,y){
  const stack=document.elementsFromPoint(x,y);
  for(const el of stack){
   if(el===b||b.contains(el)||el.matches('canvas,.tide-grain,.t-cursor,.t-toast')||el.closest('.t-toast'))continue;
   if(getComputedStyle(el).pointerEvents==='none')continue;
   const layers=[];let node=el;
   while(node&&node!==document.documentElement){const c=rgb(getComputedStyle(node).backgroundColor);if(c&&c[3]>0){layers.push(c);if(c[3]>=.99)break}node=node.parentElement}
   if(!layers.length)continue;
   let c=[17,23,28];for(let i=layers.length-1;i>=0;i--){const a=layers[i];c=c.map((v,j)=>a[j]*a[3]+v*(1-a[3]))}
   const l=c.map(v=>{v/=255;return v<=.04045?v/12.92:Math.pow((v+.055)/1.055,2.4)});
   return .2126*l[0]+.7152*l[1]+.0722*l[2];
  }
  return 0;
 }
 function update(){queued=false;if(document.hidden)return;const r=b.getBoundingClientRect();if(!r.width||!r.height)return;
  const pts=[[.5,.5],[.2,.25],[.8,.25],[.2,.75],[.8,.75]];
  const light=pts.filter(([x,y])=>surface(r.left+r.width*x,r.top+r.height*y)>.4).length>=3;
  b.classList.toggle('on-light',light);
 }
 function wake(){if(!queued){queued=true;requestAnimationFrame(update)}}
 addEventListener('scroll',wake,{passive:true});addEventListener('resize',wake,{passive:true});addEventListener('load',wake,{once:true});document.addEventListener('visibilitychange',wake);
 new ResizeObserver(wake).observe(document.querySelector('#tide-main')||document.body);
 wake();
})();
